import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GetComputersParams } from 'mbs-ui-shared@models/Computer';
import { ComputersStatisticModel } from 'mbs-ui-shared@models/computersStatistic';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComputersStatisticService {
  private http = inject(HttpClient);

  getComputersStatistic(params: GetComputersParams): Observable<ComputersStatisticModel> {
    return this.http.get<ComputersStatisticModel>(`api/computers/statistic`, { params });
  }

  getDashboardStatistic(params: { companyIds?: string[] } = {}): Observable<ComputersStatisticModel> {
    return this.http.get<ComputersStatisticModel>(`api/computers/statistic`, {
      params: { includes: ['applicationStatus', 'healthState', 'authStatus', 'state'], ...params }
    });
  }
}
